<template>
  <div class="search-content-card wd-shadow-lg wd-shadow-gray50">
    <v-card v-if="popularKeywords.length > 0" class="keywords-box" flat rounded="0">
      <v-card-title class="keywords-box__header">
        {{ $t('popular_search') }}
      </v-card-title>

      <v-card-text class="keywords-box__context">
        <div class="chip-list d-flex align-center flex-wrap">
          <v-chip
            v-for="(keyword, idx) in popularKeywords"
            :key="idx"
            class="keyword-chip ma-1"
            color="gray50"
            label
            variant="outlined"
            @click="onClickKeyword(keyword, SearchKeywordSource.POPULAR)"
          >
            {{ keyword }}
          </v-chip>
        </div>
      </v-card-text>
    </v-card>

    <v-card class="keywords-box" flat rounded="0">
      <v-card-title class="keywords-box__header">
        {{ $t('search_history') }}

        <!-- 清除按鈕 -->
        <v-btn v-if="historyKeyWords.length > 0" class="clear-btn" :color="'orange50'" :min-height="40" variant="text" @click="doClearHistory">
          {{ $t('all_clear') }}
        </v-btn>
      </v-card-title>

      <v-card-text class="keywords-box__context">
        <v-list class="pa-0 wd-max-h-70" density="compact">
          <v-list-item
            v-for="(keyword, idx) in historyKeyWords"
            :key="idx"
            class="keyword-list"
            @click="onClickKeyword(keyword, SearchKeywordSource.HISTORY)"
          >
            {{ keyword }}
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { SearchKeywordSource } from '@/view-models/gtm'

export default {
  name: 'SearchContentCard',
  props: {
    popularKeywords: { type: Array, default: () => [] },
    historyKeyWords: { type: Array, default: () => [] },
  },
  emits: ['changeKeyword'],
  setup() {
    return { SearchKeywordSource }
  },
  data() {
    return {
      searchKeywords: '',
    }
  },
  computed: {
    searchPlaceholder() {
      return this.$t('merchant_other_product')
    },
  },
  watch: {},
  created() {},
  mounted() {
    this.$store.dispatch('search/initHistorySearchKeyword')
  },
  methods: {
    onClickKeyword(keyword, keywordSource) {
      this.$emit('changeKeyword', { keyword, keywordSource })
    },
    doClearHistory() {
      this.$store.dispatch('search/removeHistorySearchKeyword')
    },
  },
}
</script>

<style lang="scss" scoped>
.search-content-card {
  .keywords-box {
    &__header {
      padding: 12px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: $gray80;
      font-size: 15px;
      font-weight: 400;

      .clear-btn {
        font-size: 15px;
      }
    }

    &__context {
      padding: 0 0 12px;

      .chip-list {
        padding: 0 20px 0 16px;
        .keyword-chip {
          color: $black50 !important;
          cursor: pointer;
        }
      }

      .keyword-list {
        padding: 0 20px;
        line-height: 40px;
        font-size: 15px;
        color: $black50;
      }
    }
  }
}
</style>
